import React, {useState} from 'react';
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    V3DQCode_translations
} from "../../../services/metadata.service";
import {Link, useParams} from "react-router-dom";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api
const columns = [
    {name: 'Code', key: 0, excel_key: 'code', json_key: 'code', data_key: 'code'},
    {name: 'Locale', key: -1, excel_key: '', json_key: 'locale', data_key: 'locale'},
    {name: 'Full Name', key: 1, excel_key: 'Name', json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 2, excel_key: 'definition', json_key: 'definition', data_key: 'definition'},
    {name: 'Description', key: 3, excel_key: 'description', json_key: 'description', data_key: 'description'},
]

const tableCols = [
    {
        label: 'Code',
        field: 'code', sort: 'disabled', width: 150
    },
    {
        label: 'Locale',
        field: 'locale', sort: 'asc', width: 150
    },
    {
        label: 'Full Name',
        field: 'full_name', sort: 'disabled', width: 150
    },
    {
        label: 'Definition',
        field: 'definition', sort: 'asc', width: 150
    },
    {
        label: 'Description',
        field: 'description', sort: 'asc', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]



const V3DQCode_translationsPage = (props) => {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;
        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'DQ Code [Translations]'}
            modal_title={'V3 Level7 DQ Code - Translations Preview'}
            sheet_name={'v3DQCode_translations'}
            columns={columns}
            tableCols={tableCols}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={V3DQCode_translations.listData}
            postAPI={V3DQCode_translations.postData}
            deleteAPI={V3DQCode_translations.deleteEntity}
            updateAPI={V3DQCode_translations.updateEntity}
            preRemoveAPI={V3DQCode_translations.preRemoveCheck}
            populate_locale={true}
        />
    );
}

export default V3DQCode_translationsPage;


